module.exports = __webpack_public_path__ + "static/media/fastLaneDrive.05a2a763.svg";